import {GameSettings, RoomSettingConstants} from '@colonist/game-base-types'
import {RoomSessionClientState} from './RoomSessionClientState'
import {BigId} from '@colonist/types'

export enum RoomCreationPhase {
    EditSettings,
    SeedOrderSelection,
    PlayOrderSelection,
}

export class RoomState {
    gameSetting: GameSettings

    roomStartTime: number
    hostSession: RoomSessionClientState
    private _guests: RoomSessionClientState[]

    isTestFreeExpansionsAndMaps: boolean
    creationPhase: RoomCreationPhase = RoomCreationPhase.EditSettings
    victoryPointsRecommendedLimit: number = RoomSettingConstants.DEFAULT_VP_TO_WIN
    victoryPointsMaxAllowed: number

    set guests(value: RoomSessionClientState[]) {
        this._guests = value
    }

    static deserialize(data: RoomState): RoomState {
        const room = new RoomState()
        room.gameSetting = data.gameSetting
        room.roomStartTime = data.roomStartTime
        room.hostSession = data.hostSession
        room.isTestFreeExpansionsAndMaps = data.isTestFreeExpansionsAndMaps
        room.creationPhase = data.creationPhase
        room._guests = [...data._guests]
        room.victoryPointsRecommendedLimit = data.victoryPointsRecommendedLimit
        room.victoryPointsMaxAllowed = data.victoryPointsMaxAllowed
        return room
    }

    getSessionCount(): number {
        return this._guests.length + 1
    }

    getSessions(): RoomSessionClientState[] {
        return [
            ...this._guests,
            this.hostSession,
        ]
    }

    getGuestSessions(): RoomSessionClientState[] {
        return [...this._guests]
    }

    getUsernames(): string[] {
        return this.getSessions().map((session) => session.username)
    }

    getUserIds(): BigId[] {
        const userIds = this.getSessions().map((session) => session.userId)
        const filteredUserIds = userIds.filter((userId: BigId | undefined) => userId != undefined)
        return filteredUserIds as BigId[]
    }

    isInRoom(session: RoomSessionClientState): boolean {
        for(const sessionInRoom of this.getSessions()) {
            if(sessionInRoom.userSessionId == session.userSessionId) return true
        }
        return false
    }

    isMultiplayer(): boolean {
        for(const session of this.getGuestSessions()) {
            if(!session.isBot) return true
        }
        return false
    }

    isHost(id: string): boolean {
        return id == this.hostSession.userSessionId
    }

    isHostSubscribed(): boolean {
        return this.hostSession.isMember
    }

    isGuest(id: string): boolean {
        return id != this.hostSession.userSessionId
    }

    isPrivateGame(): boolean {
        return this.gameSetting.privateGame
    }

    isHighKarmaGame(): boolean {
        return this.gameSetting.minimumKarma == RoomSettingConstants.HIGH_KARMA_THRESHOLD
    }
}
